import { type EmailEngineEmailType } from '@/types/emailengine';

export const groupMessagesByThreadAndEmail = (
  messages: EmailEngineEmailType[],
  account: string
): Record<string, Record<string, EmailEngineEmailType[]>> => {
  // Group messages by thread first
  const groupedByThread = messages.reduce(
    (acc, message) => {
      const threadId = message.threadId;
      if (!acc[threadId]) acc[threadId] = [];
      acc[threadId].push(message);
      return acc;
    },
    {} as Record<string, EmailEngineEmailType[]>
  );

  const groupedByEmail: Record<
    string,
    Record<string, EmailEngineEmailType[]>
  > = {};
  

  Object.entries(groupedByThread).forEach(([threadId, threadMessages]) => {
    // Find the other party in this thread (not the account holder)
    threadMessages.forEach((message) => {
      let otherParty = '';
      
      if (message.from?.address === account) {
        // Message sent by account, find recipient
        otherParty = message.to?.[0]?.address || '';
      } else {
        // Message received by account, sender is other party
        otherParty = message.from?.address || '';
      }
      
      if (otherParty && otherParty !== account) {
        if (!groupedByEmail[otherParty]) {
          groupedByEmail[otherParty] = {};
        }
        if (!groupedByEmail[otherParty][threadId]) {
          groupedByEmail[otherParty][threadId] = threadMessages;
        }
      }
    });
  });

  return groupedByEmail;
};

export const groupListByKey = <T extends Record<string, any>>(
  list: T[],
  key: keyof T
): Record<string, T[]> => {
  const listGroupedByKeys: Record<string, T[]> = {};

  const groups: string[] = [];

  if (key === 'sender') {
    const emailsToCheck = localStorage.getItem('emailsToCheck');
    list.forEach((item) => {
      const keyValue = item.from.address as string;
      // if (!emailsToCheck?.includes(keyValue)) return;
      if (!groups.includes(keyValue)) {
        groups.push(keyValue);
        listGroupedByKeys[keyValue] = [item];
      } else {
        listGroupedByKeys[keyValue].push(item);
      }
    });
  } else if (key === 'threadId') {
    list.forEach((item) => {
      const keyValue = item.threadId as string;
      if (!groups.includes(keyValue)) {
        groups.push(keyValue);
        listGroupedByKeys[keyValue] = [item];
      } else {
        listGroupedByKeys[keyValue].push(item);
      }
    });
  }

  return listGroupedByKeys;
};

// export const groupListByKey = <T extends Record<string, any>>(
//   list: T[],
//   key: keyof T
// ): Record<string, T[]> => {
//   const listGroupedByKeys: Record<string, T[]> = {};

//   const groups: string[] = [];

//   list.forEach((item) => {
//     const keyValue = item[key] as string;
//     if (!groups.includes(keyValue)) {
//       groups.push(keyValue);
//       listGroupedByKeys[keyValue] = [item];
//     } else {
//       listGroupedByKeys[keyValue].push(item);
//     }
//   });

//   console.log('THE LSIT', listGroupedByKeys);

//   return listGroupedByKeys;
// };

// export const groupListByKey = <T extends Record<string, any>>(
//   list: T[],
//   key: keyof T
// ): Record<string, T[]> => {
//   const listGroupedByKeys: Record<string, T[]> = {};

//   const groups: string[] = [];

//   if (key === 'sender')
//     list.forEach((item) => {
//       console.log('THE ITEMS', item);
//       const keyValue = item.to[0].address as string;
//       if (!groups.includes(keyValue)) {
//         groups.push(keyValue);
//         listGroupedByKeys[keyValue] = [item];
//       } else {
//         listGroupedByKeys[keyValue].push(item);
//       }
//     });
//   else if (key === 'threadId')
//     list.forEach((item) => {
//       const keyValue = item.threadId as string;
//       if (!groups.includes(keyValue)) {
//         groups.push(keyValue);
//         listGroupedByKeys[keyValue] = [item];
//       } else {
//         listGroupedByKeys[keyValue].push(item);
//       }
//     });

//   return listGroupedByKeys;
// };
